import React from 'react';
import { storeAutoScrollSettinga } from '../../components/form/react-hook-form-components/FilterStorage';
import Popup from '../../components/Popup';
import AutoScrollOptionsForm from './AutoScrollOptionsForm';

export interface AutoScrollSettings {
  autoScrollEnabled: boolean;
  scrollDelay: number;
  scrollIncrement: number;
}

interface IAutoScrollOptionsPopupProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  autoScrollSettings: AutoScrollSettings;
  setAutoScrollSettings: (settings: AutoScrollSettings) => void;
}

function AutoScrollOptionsPopup(props: IAutoScrollOptionsPopupProps) {
  const { isOpen, setIsOpen, autoScrollSettings, setAutoScrollSettings } = props;

  const closePopup = () => setIsOpen(false);

  return (
    <Popup openPopup={isOpen} setOpenPopup={setIsOpen} title="Auto Scroll Options">
      <AutoScrollOptionsForm
        currentSettings={autoScrollSettings}
        onSubmitHandler={updatedSettings => {
          const updatedAutoScrollSettings = {
            ...autoScrollSettings,
            scrollDelay: Number(updatedSettings.scrollDelay),
            scrollIncrement: Number(updatedSettings.scrollIncrement),
          } as AutoScrollSettings;
          storeAutoScrollSettinga(updatedAutoScrollSettings);
          setAutoScrollSettings(updatedAutoScrollSettings);
          closePopup();
        }}
        onCancelHandler={closePopup}
      />
    </Popup>
  );
}

export default AutoScrollOptionsPopup;
